import { encode } from 'base64-arraybuffer';

export const delay = (timeMs: number) => new Promise((resolve) => setTimeout(resolve, timeMs));

export const getBase64 = (file: File): Promise<string> => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsArrayBuffer(file);
		reader.onload = () => {
			const arrayBuffer = reader.result as ArrayBuffer;
			const base64 = encode(arrayBuffer);
			resolve(base64);
		};
		reader.onerror = (error) => reject(error);
	});
};

export const saveFile = (blob: Blob, filename: string) => {
	let link = document.createElement('a');
	link.href = window.URL.createObjectURL(blob);
	link.download = filename;
	link.click();
};

export const toTimecode = (totalSeconds: number): String => {
	const mins = Math.floor(totalSeconds / 60);
	const minStr = (mins < 10 ? '0' : '') + mins.toFixed(0);
	const secs = totalSeconds % 60;
	const secStr = (secs < 10 ? '0' : '') + secs.toFixed(2);
	return minStr + ':' + secStr;
};

export const centimetersToFeetRounded = (centimeters: number): number => {
	return Number((centimeters * 0.0328084).toFixed(2));
};

export const centimetersToMetersRounded = (centimeters: number): number => {
	return Number((centimeters / 100).toFixed(2));
};

export const feetToCentimeters = (feet: number): number => {
	return (feet * 30.48);
};

export const metersToCentimeters = (feet: number): number => {
	return (feet * 100);
};